import $ from 'jquery';

$(window).on('load scroll', () => {
	const pageTop = $(document).scrollTop();
	const pageBottom = pageTop + ($(window).height());

	$('.transition-in:not(.visible)')
		.each(function () {
			if ($(this).offset().top < pageBottom) {
				$(this).addClass('visible');
			}
		});
});
